/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 4/30/21
 * Copyright All Rights Reserved
 */
import { combineReducers } from 'redux';
import allIds from './allIds';
import byId from './byId';

export default combineReducers({
  allIds,
  byId,
});



// WEBPACK FOOTER //
// ./js/reducers/entities/inventories/index.js